<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"
                   getUrl="/web/config/customer/equipment/template/point/page" getKey="rows"
                   :columns="columns" @expandChange="expandChange">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('模板点名称')">
            <el-input v-model="yt.conditions.desc"></el-input>
          </el-form-item>
          <el-form-item :label="$t('mubandianbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
                       plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({templateId:yt.conditions.templateId,orderBy:'sequence'})">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #shifoukexiugai="scope">
        <el-select v-model="scope.row.modifiable" @change="updatePoint(scope.row)" :loading="updatePointLoading"
                   style="width: 100%">
          <el-option :label="$t('shi')" :value="true"></el-option>
          <el-option :label="$t('fou')" :value="false"></el-option>
        </el-select>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
               :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">

    </el-dialog>
  </div>
</template>

<script type="text/javascript">
// import curd_data from '@/common/curd/curd_data';
export default {
  name: 'admin_customer_info_equipment_template_point',
  data() {
    return {
      dictionaryList: [],
      templateList: [],
      templateSelect: false,
      updatePointLoading: false,
      columns: [
        {
          label: 'shifoukexiugai',
          prop: 'modifiable',
          type: 'slot',
          width: 130,
          fixed: 'right'
        },
        {
          label: 'mubandianbianma',
          prop: 'templatePoint.code',
          width: 130,
        },
        {
          label: 'miaoshu',
          prop: 'templatePoint.desc',
        },
        {
          label: 'fanyi',
          prop: 'templatePoint.i18n',
        },
        {
          label: 'shujuleixing',
          prop: 'templatePoint.dataType',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_DATATYPE'
        },
        {
          label: 'baoliuxiaoshuwei',
          prop: 'templatePoint.prec',
        },
        {
          label: 'danwei',
          prop: 'templatePoint.unit',
        },
        {
          label: 'paixu',
          prop: 'templatePoint.sequence',
        },
        {
          label: 'shuzhileixing',
          prop: 'templatePoint.type',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_TYPE'
        },
        {
          label: 'fenzu',
          prop: 'templatePoint.group',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_GROUP'
        },
        {
          label: 'laiyuan',
          prop: 'templatePoint.source',
          type: 'dictionary',
          key: 'EQUIPMENT_TEMPLATE_POINT_SOURCE'
        },
        {
          label: 'xianshizidian',
          prop: 'templatePoint.dictTypeCode',
        },
        {
          label: 'shangxianguize',
          prop: 'templatePoint.upperRules',
          type: 'tag',
          tags: {
            "fixed": {
              color: '#85CE61',
              text: this.$t('gudingzhi')
            },
            "variable": {
              color: '#9254DE',
              text: this.$t('bianliangzhi')
            }
          }
        },
        {
          label: 'morenshangxian',
          prop: 'templatePoint.upperDefault'
        },
        {
          label: 'xiaxianguize',
          prop: 'templatePoint.lowerRules',
          type: 'tag',
          tags: {
            "fixed": {
              color: '#85CE61',
              text: this.$t('gudingzhi')
            },
            "variable": {
              color: '#9254DE',
              text: this.$t('bianliangzhi')
            }
          }
        },
        {
          label: 'morenxiaxian',
          prop: 'templatePoint.lowerDefault'
        },
        {
          label: 'dangqianduanshu',
          prop: 'templatePoint.currentZone'
        },
        {
          label: 'zuizhongdiancode',
          prop: 'templatePoint.extremeCode'
        },
        {
          label: 'duanshucode',
          prop: 'templatePoint.zoneNumCode'
        }]
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        templateId: this.$attrs.templateId,
        customerId: this.$attrs.customerId,
        orderBy: 'createTime desc',
      }
      if (this.$attrs.templateId) {
        this.templateSelect = true
      }
      this.yt.SELECT_URL = "/web/template/point/getEquipmentTemplatePointByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "code"
      this.yt.get(1);
      this.utils.event_hub.$on('EQUIPMENT_TEMPLATE_POINT_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300)
  },
  methods: {

    updatePoint(obj) {
      let params = {
        customerId: this.$attrs.customerId,
        templateId: this.$attrs.templateId,
        templatePointId: obj.templatePoint.id,
        modifiable: obj.modifiable,
        id: obj.id
      }
      this.updatePointLoading = true;
      this.http.post('/web/config/customer/equipment/template/point/update', params).then(res => {
        this.utils.successMessage(this.$t(res.msg))
      }).catch((err) => {
        this.utils.errorMessage(err)
      }).finally(() => {
        this.updatePointLoading = false;
      });
    },


    // 获取字典类型
    async getSelectItemList() {
      let dictResponse = await this.http.get('/web/config/dictType/page', {
        params: {
          pageNum: 1,
          pageSize: 100
        }
      })
      let templateResponse = await this.http.get('/web/template/page', {
        params: {
          pageNum: 1,
          pageSize: 100
        }
      })
      this.dictionaryList = dictResponse.data.rows
      this.templateList = templateResponse.data.rows
    }

  }
};
</script>


<style>
</style>
